module.exports = __webpack_public_path__ + "img/40bad60.png";